import { useCallback, useEffect, useState } from "react";
import AdminLayout from "../../commponents/layout/adminLayout";

import type { TableColumn } from "../../commponents/table/types";
import { deleteProductById, getProducts } from "../../api/productApi";
import { Eye, Pencil, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DataTable from "../../commponents/table/DataTable";
import { showConfirm, showError, showSuccess } from "../../utils/ alert";

interface Product {
  id: number;
  image: string | null;
  productName: string;
  category: string;
  subCategory: string;
  stock: number;
  status: boolean;
}
export default function Product() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [products, setProducts] = useState<Product[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const columns: TableColumn<Product>[] = [
    {
      key: "image",
      title: "Image",
      render: (row) =>
        row.image ? (
          <img
            src={row.image}
            alt={row.productName}
            className="h-14 w-14 rounded-lg object-cover"
          />
        ) : (
          <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-gray-100 text-xs text-gray-400">
            No Image
          </div>
        ),
    },
    {
      key: "productName",
      title: "Product Name",
    },
    {
      key: "category",
      title: "Category",
    },
    {
      key: "subCategory",
      title: "Sub Category",
    },
    {
      key: "stock",
      title: "Stock",
    },
    {
      key: "status",
      title: "Status",
      render: (row) => (
        <span
          className={`rounded-full px-3 py-1 text-xs font-medium ${
            row.status
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}>
          {row.status ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      key: "id",
      title: "Action",
      render: (row) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleDetail(row.id)}
            className="rounded-lg bg-blue-100 p-2 text-blue-600 hover:bg-blue-200">
            <Eye size={18} />
          </button>

          <button
            onClick={() => handleEdit(row.id)}
            className="rounded-lg bg-yellow-100 p-2 text-yellow-600 hover:bg-yellow-200">
            <Pencil size={18} />
          </button>

          <button
            onClick={() => handleDelete(row.id)}
            className="rounded-lg bg-red-100 p-2 text-red-600 hover:bg-red-200">
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];

  const fetchProducts = async () => {
    try {
      setLoading(true);

      // FIX: search sebelumnya tidak pernah dikirim ke API, jadi
      // ketikan di search box tidak ngefek sama sekali ke hasil.
      const response = await getProducts({
        page: currentPage,
        limit: pageSize,
        search,
      });

      setProducts(response.data.productList);

      setTotalPages(response.data.pagination.totalPages);

      setTotalData(response.data.pagination.totalData);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();

    // FIX: `search` sebelumnya tidak ada di dependency array, jadi
    // perubahan keyword search tidak memicu fetch ulang.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, search]);

  const handleDetail = (id: number) => {
    navigate(`/product/detail/${id}`);
  };

  const handleEdit = (id: number) => {
    navigate(`/product/edit/${id}`);
  };

  const handleDelete = async (id: number) => {
   

    try {
      const confirmed = await showConfirm(
        "Are you sure you want to delete this product?"
      );

   

      if (!confirmed) return;

  

      await deleteProductById(id);

      await showSuccess("Product deleted successfully.");

      fetchProducts();
    } catch (error) {

      showError("Failed to delete product.");
    }
  };


  const handleSearch = useCallback((value: string) => {
    setSearch(value);
    setCurrentPage(1);
  }, []);

  return (
    <AdminLayout>
      <div className="bg-white rounded-3xl p-6">
        <DataTable
          title="Product List"
          columns={columns}
          data={products}
          onAdd={() => navigate("/product/add")}
          searchPlaceholder="Search Product"
          onSearch={(value) => {

            // FIX: reset ke halaman 1 tiap kali keyword search berubah,
            // supaya tidak "nyangkut" di halaman kosong (mis. lagi di
            // halaman 3 lalu ngetik keyword baru yang hasilnya cuma 1 halaman).
            setSearch(value);
            setCurrentPage(1);
          }}
          showFilter={false}
          pagination={{
            currentPage,
            totalPages,
            pageSize,
            onPageChange: (page) => {
     
              setCurrentPage(page);
            },
            onPageSizeChange: (size) => {
     
              setPageSize(size);
              setCurrentPage(1);
            },
          }}
        />
      </div>
    </AdminLayout>
  );
}
